import { TFunction } from "i18next";

export const getCreatedByLabel = (
  t: TFunction,
  tenantName: string | undefined,
  createdByFullName: string | null,
  isCreatedByInternal: boolean
) => {
  if (isCreatedByInternal && createdByFullName) {
    return t("pickupRequests.grid.createdByStaff", {
      name: createdByFullName,
      tenantName,
    });
  }

  // The server nulls an internal creator's name for an external caller, so the name is absent
  // exactly when the creator was staff - without this the participant sees an empty value.
  if (isCreatedByInternal) {
    return t("pickupRequests.grid.createdByAdministrator");
  }

  return createdByFullName || "";
};

export default getCreatedByLabel;
